import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

//Global theme to keep the application looking consistent
export const globalTheme = makeStyles((theme: Theme) =>
	createStyles({
		searchBar: {
			padding: theme.spacing(1),
		},
		fab: {
			position: 'absolute',
			top: theme.spacing(9),
			right: theme.spacing(2),
		},
		fabItems: {
			position: 'absolute',
			top: theme.spacing(9),
			right: theme.spacing(9),
		},
		margin: {
			margin: theme.spacing(1),
		},
		modalImportBody: {
			top: '50%',
			left: '50%',
			transform: `translate(-50%, -50%)`,
			position: 'absolute',
			width: '90%',
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
		},
		options: {
			marginLeft: theme.spacing(1),
		},

		//Main pages
		PageMain: {
			paddingTop: '10px',
			display: 'flex',
			flexFlow: 'column',
			height: '100%',
		},
		PageHeading: {
			display: 'flex',
			flex: "0 1 auto",
			paddingTop: '8px',
			minHeight: '70px',
		},
		PageFilter: {
			flex: "0 1 auto",
		},
		PageContent: {
			flex: "1 1 auto",
			paddingBottom: theme.spacing(1)
		},
		PageFieldsFullHeight: {
			display: 'flex',
			flex: "0 1 auto",
			flexDirection: 'row',
			flexWrap: 'wrap',
			height: '100%'
		},
		DataGridContent: {
			width: "1600px",
			height: '100%',
			[theme.breakpoints.up(1359)]: {
				width: "1600px"                   
			},
			[theme.breakpoints.up(1914)]: {
				width: "1920px"                   
			},
			[theme.breakpoints.up(2552)]: {
				width: "2380px"                   
			},
			paddingBottom: theme.spacing(1),
		},

		// Large Modal page
		ModalMain: {
			top: "50%",
			left: "50%",
			transform: `translate(-50%, -50%)`,
			position: 'absolute',
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 2, 2, 2),
			width: '95vw',
			height: '95vh',
		},
		// Medium Modal Page
		ModalMainMedium: {
			top: "50%",
			left: "50%",
			transform: `translate(-50%, -50%)`,
			position: 'absolute',
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 2, 2, 2),
			width: '60vw',
			height: '80vh',
		},
		// Narrow Modal Page
		ModalMainNarrow: {
			top: "50%",
			left: "50%",
			transform: `translate(-50%, -50%)`,
			position: 'absolute',
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 2, 2, 2),
			width: '30vw',
			height: '80vh',
			minWidth: '400px'
		},
		// Mini Modal Page
		ModalMainMini: {
			top: "30%",
			left: "30%",
			transform: `translate(-70%, -70%)`,
			position: 'absolute',
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 2, 2, 2),
			width: '20vw',
			height: '25vh',
			minWidth: '200px'
		},

		ModalBody: {
			display: 'flex',
			flexFlow: 'column',
			height: '100%',
		},
		ModalContent: {
			display: 'flex',
			flexFlow: 'column',
			height: '100%',
			overflowY: 'auto',
		},
		ModalHeading: {
			flex: "0 1 auto",
			marginTop: theme.spacing(0),
			marginBottom: theme.spacing(0.5)
		},
		ModalFields: {
			display: 'flex',
			flex: "0 1 auto",
			flexDirection: 'row',
			flexWrap: 'wrap'
		},
		ModalFill: {
			flex: "1 1 auto",
			margin: theme.spacing(1),
		},
		ModalFooter: {
			display: 'flex',
			flex: "0 1 55px",
			height: '55px',
			justifyContent: 'flex-end'
		},
		ModalContentHeading: {
			margin: theme.spacing(1),
			flex: 1,
			flexBasis: `calc(100% - ${theme.spacing(1)} * 2)`,
			fontWeight: 'bold'
		},
		ModalContentField: {
			margin: theme.spacing(0.9),
			flexBasis: `calc((100% - ${theme.spacing(0.9)} * 8) / 4)`,
			[theme.breakpoints.down('md')]: {
				flexBasis: `calc((100% - ${theme.spacing(0.9)} * 4) / 2)`,
			},
			[theme.breakpoints.down('sm')]: {
				flexBasis: `calc(100% - ${theme.spacing(0.9)} * 2)`,
			},
			display: 'flex'
		},
		ModalInnerContentFieldLeft: {
			margin: theme.spacing(0,0.5,0,0),
			flexBasis: `calc(50% - ${theme.spacing(0.5)})`,
			display: 'flex'
		},
		ModalInnerContentFieldRight: {
			margin: theme.spacing(0,0,0,0.5),
			flexBasis: `calc(50% - ${theme.spacing(0.5)})`,
			display: 'flex'
		},
		ModalInnerContentFieldOneThirdWidthLeft: {
			margin: theme.spacing(0,0.5,0,0),
			flex: 1,
			flexBasis: `calc(33.33% - ${theme.spacing(0.5)})`,
		},
		ModalInnerContentFieldOneThirdWidthMiddle: {
			margin: theme.spacing(0,0.5,0,0.5),
			flex: 1,
			flexBasis: `calc(33.33% - ${theme.spacing(0.5)} * 2)`,
		},
		ModalInnerContentFieldOneThirdWidthRight: {
			margin: theme.spacing(0,0,0,0.5),
			flex: 1,
			flexBasis: `calc(33.33% - ${theme.spacing(0.5)})`,
		},
		ModalInnerContentFieldTwoThirdWidthLeft: {
			margin: theme.spacing(0,0.5,0,0),
			flex: 1,
			flexBasis: `calc(66.66% - ${theme.spacing(0.5)})`,
		},
		ModalInnerContentFieldTwoThirdWidthRight: {
			margin: theme.spacing(0,0,0,0.5),
			flex: 1,
			flexBasis: `calc(66.66% - ${theme.spacing(0.5)})`,
		},
		ModalInnerContentFieldOneQuarterWidthLeft: {
			margin: theme.spacing(0,0.5,0,0),
			flex: 1,
			flexBasis: `calc(25% - ${theme.spacing(0.5)})`,
		},
		ModalInnerContentFieldOneQuarterWidthMiddle: {
			margin: theme.spacing(0,0,0,0),
			flex: 1,
			flexBasis: `calc(25% - ${theme.spacing(0)})`,
		},
		ModalInnerContentFieldThreeQuarterWidthRight: {
			margin: theme.spacing(0,0,0,0.5),
			flex: 1,
			flexBasis: `calc(75% - ${theme.spacing(0.5)})`,
		},
		ModalContentFieldOneTenthWidthLeft: {
			margin: theme.spacing(1,0.5,1,1),
			flex: 1,
			flexBasis: `calc(10.0% - ${theme.spacing(1)})`,
		},
		ModalContentFieldOneTenthWidthRight: {
			margin: theme.spacing(1,1,1,0.5),
			flex: 1,
			flexBasis: `calc(10.0% - ${theme.spacing(1)})`,
		},
		ModalContentFieldTwoTenthWidthLeft: {
			margin: theme.spacing(1,0.5,1,1),
			flex: 1,
			flexBasis: `calc(20.0% - ${theme.spacing(1)})`,
		},
		ModalContentFieldTwoTenthWidthRight: {
			margin: theme.spacing(1,1,1,0.5),
			flex: 1,
			flexBasis: `calc(20.0% - ${theme.spacing(1)})`,
		},
		ModalContentFieldOneQuarterWidth: {
			margin: theme.spacing(0.5),
			flex: 1,
			flexBasis: `calc(25% - ${theme.spacing(0.5)} * 2)`,
		},
		ModalContentFieldThreeQuarterWidth: {
			margin: theme.spacing(0.5),
			flex: 1,
			flexBasis: `calc(75% - ${theme.spacing(0.5)} * 2)`,
		},
		ModalContentFieldOneThirdWidth: {
			margin: theme.spacing(0.9),
			flexBasis: `calc((100% - ${theme.spacing(0.9)} * 6) / 3)`,
			[theme.breakpoints.down('md')]: {
				flexBasis: `calc(100% - ${theme.spacing(0.9)} * 2)`,
			},
			display: 'flex'
		},
		ModalContentFieldHalfWidth: {
			margin: theme.spacing(1),
			flex: 1,
			flexBasis: `calc(50% - ${theme.spacing(1)} * 2)`,
		},
		ModalContentFieldFullWidth: {
			margin: theme.spacing(1),
			flex: 1,
			flexBasis: `calc(100% - ${theme.spacing(1)} * 2)`,
		},
		ModalDivider: {
			flex: "1 1 20px",
		},
		//TOREMOVE
		ModalSubHeading: {
			height: '30px',
			width: '100%',
		},

		NumberTextField: {
			'& input[type=number]': {
				'-moz-appearance': 'textfield'
			},
			'& input[type=number]::-webkit-outer-spin-button': {
				'-webkit-appearance': 'none',
				margin: 0
			},
			'& input[type=number]::-webkit-inner-spin-button': {
				'-webkit-appearance': 'none',
				margin: 0
			}
		},

		NumberTextFieldRed: {
			'& input[type=number]': {
				'-moz-appearance': 'textfield'
			},
			'& input[type=number]::-webkit-outer-spin-button': {
				'-webkit-appearance': 'none',
				margin: 0
			},
			'& input[type=number]::-webkit-inner-spin-button': {
				'-webkit-appearance': 'none',
				margin: 0
			},
			'& ':
			{backgroundColor: 'rgba(255, 0, 0, 0.55)'}
		},

		Table: {
			border: 2,
			borderColor: "gray",
			borderStyle: "solid",
			borderRadius: 5,
			boxShadow: "none"
		},
		TableRow: {
			backgroundColor: theme.palette.background.default,
			borderTop: 1.5,
			borderLeft: 0,
			borderRight: 0,
			borderBottom: 0,
			borderColor: "gray",
			borderStyle: "solid",
		}
	}),
);
